import type {ReactElement} from 'react';
import {NavLink} from 'react-router-dom';
import {Trans} from '@lingui/macro';
import Logo from '@components/Logo/Logo';
import styles from './menu.module.scss';

export default function Menu(): ReactElement {
    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <Logo className={styles.logo} />
            </div>
            <NavLink to="/">
                <div className={styles.item}>
                    <Trans>← Back to platform</Trans>
                </div>
            </NavLink>
            <NavLink to="/admin/users">
                <div className={styles.item}>
                    <Trans>Users</Trans>
                </div>
            </NavLink>
            <NavLink to="/admin/promocodes">
                <div className={styles.item}>
                    <Trans>Promocodes</Trans>
                </div>
            </NavLink>
            <div className={styles.flexer} />
            <NavLink to="/profile">
                <div className={styles.item}>
                    <Trans>Profile</Trans>
                </div>
            </NavLink>
        </div>
    );
}
